import { useAtomValue } from 'jotai';

import { ChatDrawerControlMenuItem } from '../../../session/controls/ChatDrawerControl';
import { useChatDrawerButtonUtils } from '../../chat/useChatDrawerButtonUtils';
import { MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import { VisitorDrawerState, visitorDrawerStateAtom } from '../../state';

export function VisitorMeetingChatDrawerMenuItemWrapper() {
  const drawerState = useAtomValue(visitorDrawerStateAtom);
  const { unreadMessagesCount, toggleChatDrawer, isChatDrawerDisabled } = useChatDrawerButtonUtils();

  return (
    <ChatDrawerControlMenuItem
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
      isChatDrawerOpen={drawerState === VisitorDrawerState.CHAT}
      onClickChatButton={toggleChatDrawer}
      isChatButtonDisabled={isChatDrawerDisabled}
      unreadMessageCount={unreadMessagesCount}
    />
  );
}
